// extracted by mini-css-extract-plugin
export default {"Rating":"styles_Rating__YVCL8","star":"styles_star__bok+N","red":"styles_red__RgKbs","orange":"styles_orange__ce4ss","green":"styles_green__PUevg"};